// remember luxon has lots of methods for formatting dates and times
// only make a new format if it doesn't exist here...
// https://moment.github.io/luxon/#/formatting

// options cheat sheet https://devhints.io/wip/intl-datetime
// https://moment.github.io/luxon/#/formatting

export const intlDateTimeFormatObjects = {
    MONTH_DAYOFMONTH_12TIME: {
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }, // 2 Jul 5:30 PM
    MONTH_DAYOFMONTH: { day: 'numeric', month: 'short' }, // 2 Jul
    MONTH_YEAR: { year: 'numeric', month: 'long' }, // July 2023,
    LONG_DAY_MONTH_YEAR_TIME: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }, // Friday, 28 June 2024 at 6:29 pm
    SHORT_DAY_MONTH_YEAR_TIME: {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    } // Fr, 28 Jun 2024 at 6:29 pm
}
